import React, {useEffect} from 'react';
import {Route, Switch, useHistory, useParams} from 'react-router-dom';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';

import {loadDocumentInfo, loadOrderInfo} from '../redux/actions/orderActions';
import Header from './components/Header';
import {getImageUrl} from '../api/iposApi';
import GreenBillPage from '../pages/green_bill/GreenBillPage';
import {setGeneralErrorTranslationKey} from '../redux/actions/baseActions';

function GreenBillLayout({
                           loadOrderInfo,
                           currentLanguageId,
                           branchInfo,
                           loadDocumentInfo,
                           setGeneralErrorTranslationKey
                         }) {
  const {branchId, orderId} = useParams();
  const history = useHistory();

  const fetchData = async () => {
    const res = await loadDocumentInfo(branchId, currentLanguageId, orderId);
    if (!res || (res && (res.error_message || res == ''))) {
      setGeneralErrorTranslationKey('order_info.no_content_error');
      history.push(`/${branchId}/error`);
    }
  };

  useEffect(() => {
    fetchData();
  }, [currentLanguageId]);

  return (
    <>
      <div
        className={ 'restaurant-layout green-bill-layout' }
        id={ 'scrollable-restaurant-layout' }
        style={ {
          backgroundImage: `url(${getImageUrl(branchInfo.BannerImageName)})`
        } }
      >
        <Switch>
          <Route exact path="/:branchId/green_bill/:orderId" component={ GreenBillPage } />
        </Switch>
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  const {
    currentLanguageId,
    branchInfo
  } = state;

  return {
    currentLanguageId,
    branchInfo
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      loadOrderInfo,
      loadDocumentInfo,
      setGeneralErrorTranslationKey
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(GreenBillLayout);
